module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_8011.83b1e919.png";